import { topicItems } from '@/mocks/homeData';

export default function SectionTopics() {
  return (
    <section id="topics" className="py-14 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6 max-w-6xl mx-auto">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-3xl font-bold text-foreground-950 font-heading">热门话题</h2>
          <p className="mt-3 text-sm text-foreground-600">全网剧迷正在热议的影视话题，加入讨论</p>
        </div>
        <div className="flex flex-wrap gap-3 justify-center">
          {topicItems.map((item) => (
            <a
              key={item.id}
              href="#ranking"
              className="inline-flex items-center gap-3 px-5 py-3 rounded-xl bg-background-100 border border-background-200/70 hover:border-primary-300/40 transition-colors cursor-pointer group"
            >
              <span className="text-sm font-medium text-foreground-800 whitespace-nowrap group-hover:text-primary-500 transition-colors">
                {item.tag}
              </span>
              <span className="text-xs text-foreground-500 whitespace-nowrap">{item.heat}</span>
              {item.trend === 'hot' && (
                <i className="ri-fire-line text-accent-500 text-xs"></i>
              )}
              {item.trend === 'new' && (
                <span className="px-1.5 py-0.5 rounded-md bg-primary-500/10 text-primary-500 text-xs font-medium whitespace-nowrap">NEW</span>
              )}
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}